import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../dialog/Dialog';
import BrowserWarningMessageDE from './BrowserWarningMessageDE';
import BrowserWarningMessageEN from './BrowserWarningMessageEN';
var UNSUPPORTED_BROWSER_TAG = 'ua-ie';
var getLanguage = function getLanguage() {
  if (window) {
    return window.navigator.language.toLowerCase();
  }
  return '';
};
var BrowserWarning = function BrowserWarning(props) {
  var show = props.show,
    onClose = props.onClose,
    onBrowserSelect = props.onBrowserSelect;
  var _useState = useState(show),
    _useState2 = _slicedToArray(_useState, 2),
    showWarning = _useState2[0],
    setShowWarning = _useState2[1];
  var handleClose = function handleClose() {
    setShowWarning(false);
    onClose(false);
  };

  // Force to show the dialog from outside
  useEffect(function () {
    return setShowWarning(show);
  }, [show]);

  // check HTML tag for browsers only on mount
  useEffect(function () {
    if (document && document.documentElement && document.documentElement.classList.contains(UNSUPPORTED_BROWSER_TAG)) {
      setShowWarning(true);
    }
  }, []);
  var lang = getLanguage();
  var isDE = lang.startsWith('de');
  var body = isDE ? /*#__PURE__*/React.createElement(BrowserWarningMessageDE, {
    onBrowserSelect: onBrowserSelect
  }) : /*#__PURE__*/React.createElement(BrowserWarningMessageEN, {
    onBrowserSelect: onBrowserSelect
  });
  var footerText = isDE ? 'Weiter im IE11' : 'Continue with IE11';
  var footer = /*#__PURE__*/React.createElement("div", {
    className: "display-flex justify-content-end"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-link",
    onClick: handleClose
  }, footerText));
  return /*#__PURE__*/React.createElement(Dialog, {
    show: showWarning,
    className: "backdrop-blured",
    body: body,
    footer: footer,
    onHide: handleClose
  });
};
BrowserWarning.defaultProps = {
  onClose: function onClose() {},
  onBrowserSelect: function onBrowserSelect() {}
};
BrowserWarning.propTypes = {
  onClose: PropTypes.func,
  onBrowserSelect: PropTypes.func
};
export default BrowserWarning;